var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "transactions_detail"
  }, [!_vm.evmTransactions ? [_c('Loader', {
    attrs: {
      "content-id": "",
      "message": "Fetching Transactions"
    }
  })] : [_vm._m(0), _vm.evmTransactions.length > 0 ? [_c('EVMTransactions', {
    attrs: {
      "txs": _vm.filteredTransactions,
      "limits": _vm.transactionsOffsets
    },
    on: {
      "update": _vm.updateOffset,
      "next": _vm.nextPage,
      "back": _vm.previousPage
    }
  })] : [_c('Loader', {
    attrs: {
      "content-id": "",
      "message": "Fetching Transactions"
    }
  })]]], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "headers"
  }, [_c('h2', [_vm._v("Transactions")])]);
}]

export { render, staticRenderFns }